var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-chip',_vm._b({attrs:{"label":"","color":"green white--text","x-small":""}},'v-chip',{ ..._vm.$props },false),[_vm._v(" "+_vm._s(_vm.roleName)+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }